module.exports = {
	"Aggressive Allocation": 19,
	"China Region": 1,
	"Commodities Focused": 1,
	"Communications": 26,
	"Consumer Cyclical": 38,
	"Consumer Defensive": 16,
	"Diversified Emerging Mkts": 5,
	"Diversified Pacific/Asia": 6,
	"Energy Limited Partnership": 27,
	"Equity Energy": 52,
	"Equity Precious Metals": 29,
	"Europe Stock": 34,
	"Financial": 52,
	"Foreign Large Blend": 276,
	"Foreign Large Growth": 122,
	"Foreign Large Value": 143,
	"Foreign Small/Mid Blend": 26,
	"Foreign Small/Mid Growth": 39,
	"Foreign Small/Mid Value": 28,
	"Global Aggressive Allocation": 27,
	"Global Large-Stock Blend": 134,
	"Global Large-Stock Growth": 90,
	"Global Large-Stock Value": 59,
	"Global Moderate Allocation": 65,
	"Global Moderately Aggressive Allocation": 40,
	"Global Moderately Conservative Allocation": 2,
	"Global Real Estate": 52,
	"Global Small/Mid Stock": 60,
	"Health": 87,
	"Industrials": 45,
	"Infrastructure": 45,
	"Japan Stock": 27,
	"Large Blend": 621,
	"Large Growth": 401,
	"Large Value": 440,
	"Mid-Cap Blend": 205,
	"Mid-Cap Growth": 166,
	"Mid-Cap Value": 165,
	"Miscellaneous Allocation": 4,
	"Miscellaneous Region": 44,
	"Miscellaneous Sector": 29,
	"Moderate Allocation": 101,
	"Moderately Aggressive Allocation": 34,
	"Moderately Conservative Allocation": 3,
	"Natural Resources": 75,
	"Pacific/Asia ex-Japan Stk": 5,
	"Real Estate": 91,
	"Small Blend": 248,
	"Small Growth": 148,
	"Small Value": 162,
	"Tactical Allocation": 22,
	"Target-Date 2025": 3,
	"Target-Date 2030": 31,
	"Target-Date 2035": 37,
	"Target-Date 2040": 40,
	"Target-Date 2045": 41,
	"Target-Date 2050": 41,
	"Target-Date 2055": 41,
	"Target-Date 2060": 40,
	"Target-Date 2065+": 61,
	"Technology": 176,
	"Utilities": 26
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersPeers.json
// module id = 966
// module chunks = 0